module.exports = __webpack_public_path__ + "static/media/patron-1.228cd9db.svg";